import {
    ActivityModel,
    ActivityGroupModel,
    ActivityStatusModel,
    ActivityRhythm,
    LocationModel,
} from '../../models';

import { updateDateWithTime } from '../../services/dates';

import {BASIC_QUEST_INDEXNAME, PERIODIC_QUEST_INDEXNAME, ONLINE_QUEST_INDEXNAME} from '../../config/constants';

const initState = {
    name: null,
    isActive: false,
    description: null,
    experience: [],
    experiences: [],
    image: null,
    locationType: true,
    location: {
        id: null,
        city: null,
        organization: null,
        name: null,
        place: null,
        additions: null,
    },
    rhythmRepeat: undefined,
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    activityDates: null,
    pointsApplyStrategy: 'scan',
    status: null,
    ageFrom: null,
    ageTo: null,
    cities: [],
    notActiveSteps: [],
    validSteps: [],
    savedQuest: null,
    responsible: [],
    useOrganizationData: false,
    participants: [],
    skipStepsCallbacks: {},
    volunteers: [],
    selectedDays: [],
    isResponsible: false,
    onlineQuestLink: null,
    points: null,
    onlineQuestPointsApplyHash: null,
    additionalInfoTitle: null,
    additionalInfoLink: null,
    additionalInfoPromoteTitle: null,
    additionalInfoPromoteLink: null,
    onlineActivityGroupId: null,
    pointsPerShare: null,
    sharesPerQuest: null,
};
export default {
    namespaced: true,
    state: {
        ...initState,
        steps: [],
        rhythms: [],
        visibilityStatuses: [],
    },
    getters: {
        city(state) {
            return state.cities.find(c => c.id === state.location.city) || null;
        },
        getQuestData(state, getters, rootState) {
            let  activityType, activityGroup, activityDates = null;
            if (state.locationType === null) {
                activityType = ONLINE_QUEST_INDEXNAME;
                activityGroup = state.onlineActivityGroupId;
            } else {
                activityType = state.rhythmRepeat === null ? BASIC_QUEST_INDEXNAME : PERIODIC_QUEST_INDEXNAME;
                activityGroup = rootState.questList.activityGroup ? rootState.questList.activityGroup.id : null;
            }
            if (state.activityDates) {
                activityDates = state.activityDates.map(d => ({
                    ...Object.assign({}, d),
                    date: new Date(d.date.date),
                }));
            }

            const startDate = state.startTime ? updateDateWithTime(state.startTime, state.startDate) : state.startDate;
            const endDate = state.endTime ? updateDateWithTime(state.endTime, state.endDate) : state.endDate;
            const res = {
                name: state.name,
                isActive: state.isActive,
                ageFrom: state.ageFrom || 0,
                ageTo: state.ageTo || 0,
                startDate: startDate,
                endDate: endDate,
                logo: state.image,
                description: state.description,
                postCode: getters.city ? getters.city.postcode : null,
                location: getters.city ? getters.city.name : null,
                locationAdditions: state.location.additions || '',
                street: state.location.place,
                placeName: state.location.name,
                experiences: state.experience,
                activityType: activityType,
                activityDates: activityDates,
                responsibleActivities: state.responsible,
                participantActivities: state.participants,
                rhytm: state.rhythmRepeat,
                activityStatus: state.status,
                pointsApplyStrategy: state.pointsApplyStrategy,
                organization: rootState.organization.selectedOrganizationID,
                activityGroup: activityGroup,
                isResponsible: state.isResponsible,
                pointsPerShare: state.pointsPerShare,
                sharesPerQuest: state.sharesPerQuest,
                useOrganizationData: state.useOrganizationData,
            };

            if (state.locationType === null) {
                res.activityOnline = {
                    surveyLink: state.onlineQuestLink,
                    points: state.points,
                    hash: state.onlineQuestPointsApplyHash,
                    moreTitle: state.additionalInfoTitle,
                    moreLink: state.additionalInfoLink,
                    nextActivityTitle: state.additionalInfoPromoteTitle,
                    nextActivityLink: state.additionalInfoPromoteLink,
                };
            }

            return res;
        },
    },
    mutations: {
        setName(state, val) {
            state.name = val;
        },
        setDescription(state, val) {
            state.description = val;
        },
        setExperience(state, val) {
            state.experience = val;
        },
        setExperiences(state, val) {
            state.experiences = val;
        },
        setImage(state, val) {
            state.image = val;
        },
        setLocation(state, val) {
            state.location = val;
        },
        resetLocation(state) {
            state.location = initState.location;
        },
        setRhythmRepeat(state, val) {
            state.rhythmRepeat = val;
        },
        setRhythms(state, val) {
            state.rhythms = val;
        },
        setStartDate(state, startDate) {
            state.startDate = startDate;
        },
        setEndDate(state, endDate) {
            state.endDate = endDate;
        },
        setStartTime(state, startTime) {
            state.startTime = startTime;
        },
        setEndTime(state, endTime) {
            state.endTime = endTime;
        },
        setActivityDates(state, activityDates) {
            state.activityDates = activityDates;
        },
        toggleActivityDate(state, activityDate) {
            for (const date of state.activityDates) {
                if (date.date == activityDate.date) {
                    date.isActive = activityDate.isActive;
                }
            }
        },
        setPointsApplyStrategy(state, pointsApplyStrategy) {
            state.pointsApplyStrategy = pointsApplyStrategy;
        },
        setStatus(state, status) {
            state.status = status;
        },
        setAgeFrom(state, ageFrom) {
            state.ageFrom = ageFrom;
        },
        setAgeTo(state, ageTo) {
            state.ageTo = ageTo;
        },
        setLocationType(state, val) {
            state.locationType = val;
        },
        setCities(state, val) {
            state.cities = val;
        },
        setIsResponsible(state, isResponsible) {
            state.isResponsible = isResponsible;
        },
        addStep(state, step) {
            state.steps.push(step);
        },
        addNotActiveStep(state, step) {
            state.notActiveSteps.push(step);
        },
        removeNotActiveStep(state, step) {
            state.notActiveSteps = state.notActiveSteps.filter(notActstepiveStep => notActstepiveStep != step);
        },
        addValidStep(state, step) {
            state.validSteps.push(step);
        },
        removeValidStep(state, step) {
            state.validSteps = state.validSteps.filter(validStep => validStep != step);
        },
        resetState(state) {
            Object.keys(initState).forEach(key => {
                state[key] = initState[key];
            });
        },
        setSavedQuest(state, quest) {
            state.savedQuest = quest;
        },
        setResponsible(state, responsible) {
            state.responsible = responsible;
        },
        setUseOrganizationData(state, useOrganizationData) {
            state.useOrganizationData = useOrganizationData;
        },
        setParticipants(state, participants) {
            state.participants = participants;
        },
        addSkipStepsCallback(state, val) {
            state.skipStepsCallbacks[val.stepId] = val.callback;
        },
        setVolunteers(state, val) {
            state.volunteers = val;
        },
        setSelectedDays(state, val) {
            state.selectedDays = val;
        },
        setIsActive(state, val) {
            state.isActive = val;
        },
        setOnlineQuestLink(state, val) {
            state.onlineQuestLink = val;
        },
        setPoints: (state, points) => state.points = points,
        setOnlineQuestPointsApplyHash(state, val) {
            state.onlineQuestPointsApplyHash = val;
        },
        setAdditionalInfoLink: (state, additionalInfoLink) => state.additionalInfoLink = additionalInfoLink,
        setAdditionalInfoTitle: (state, additionalInfoTitle) => state.additionalInfoTitle = additionalInfoTitle,
        setAdditionalInfoPromoteLink: (state, additionalInfoPromoteLink) => state.additionalInfoPromoteLink = additionalInfoPromoteLink,
        setAdditionalInfoPromoteTitle: (state, additionalInfoPromoteTitle) => state.additionalInfoPromoteTitle = additionalInfoPromoteTitle,
        setOnlineActivityGroupId: (state, val) => state.onlineActivityGroupId = val,
        setVisibilityStatuses: (state, val) => state.visibilityStatuses = val,
        setPointsPerShare: (state, val) => state.pointsPerShare = val,
        setSharesPerQuest: (state, val) => state.sharesPerQuest = val,
    },
    actions: {
        loadVisibilityStatuses({ commit }) {
            return ActivityStatusModel.get({
                params: {
                    'response-group': 'activity_editor',
                },
            })
                .then(r => r.data)
                .then(visibilityStatuses => {
                    commit('setVisibilityStatuses', visibilityStatuses);
                });
        },
        loadRhythms({ commit }) {
            return ActivityRhythm.get({
                params: {
                    'order-by': [
                        {
                            field: 'ordering',
                            direction: 'ASC',
                            type: 'field',
                        },
                    ],
                },
            })
                .then(r => r.data)
                .then(rhythms => {
                    commit('setRhythms', rhythms);
                });
        },
        saveQuest({ state, getters, commit }) {
            let promises = [];

            promises.push(
                ActivityModel
                    .create({
                        params: {
                            'response-group': 'org_backend_quest_details',
                        },
                        body: getters.getQuestData,
                    })
                    .then(response => {
                        commit('setSavedQuest', response);
                    })
            );

            promises.push(LocationModel.saveQuestLocaion(state.location));

            return Promise.all(promises);
        },
        async ensureOnlineActivityGroup({state, commit, rootState}) {
            if (!state.onlineActivityGroupId) {
                ActivityGroupModel
                    .get({
                        params: {
                            'response-group': 'short',
                            filter: [
                                {
                                    type: 'eq',
                                    field: 'name',
                                    value: 'Online Quests',
                                },
                                {
                                    type: 'eq',
                                    field: 'organization',
                                    value: rootState.organization.selectedOrganizationID,
                                },
                            ],
                            limit: 1,
                        },
                    })
                    .then(r => {
                        if (!r.total_items) {
                            return ActivityGroupModel
                                .create({
                                    body: {
                                        name: 'Online Quests',
                                        organization: rootState.organization.selectedOrganizationID,
                                    },
                                    params: {
                                        'response-group': 'short',
                                    },
                                })
                                .then(r => commit('setOnlineActivityGroupId', r.id));
                        } else {
                            commit('setOnlineActivityGroupId', r.data[0].id);
                        }
                    });
            }
        },
    },
};
